import { get, post } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;

const loadExposure = (documentId, siteId) => get(`${url}/exposure/${documentId}/${siteId}`);
const computeExposure = (documentId, siteId) => post(`${url}/exposure/compute`, { documentId, siteId });
const retrieveExposureCurrencies = (documentId, siteId) =>
  post(`${url}/exposure/retrieve-currencies`, { documentId, siteId });

const exp = {
  loadExposure,
  computeExposure,
  retrieveExposureCurrencies
};
export default exp;
